export default (errors, dispatch, submitError) => {

  //

}
